module.exports = __webpack_public_path__ + "img/icey-back.c91a075b.png";